<mat-card>
  <img [src]="bundleTemplate().images[0]?.large ?? bundleTemplate().images[0]?.small" width="auto" height="72px" alt="banner image">

  <p>{{ bundleTemplate().description }}</p>
</mat-card>
